var url_ressource = process.env.REACT_APP_URL_RESSOURCES

if (url_ressource === undefined) {
  if (process.env.REACT_APP_ENV === "developement") {
    url_ressource = "http://192.168.1.186/api/v1/ressources/images/"
  }
}

export default url_ressource
